import { createSlice } from '@reduxjs/toolkit'
import * as asyncActions from '../Profile/profile.asyncActions'

const initialState = {
	user: {},
}

const slice = createSlice({
	name: 'profile',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(asyncActions.fetchUser.fulfilled, (state, action) => {
			state.user = action.payload || initialState.user
		})
	},
})

export default slice

export const { profile, actions } = slice
